/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  Card,
  CardContent,
  CardMedia,
  TextField,
  InputAdornment,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { useNavigate } from "react-router-dom";
import API from "../../Utils/Interceptor/ApiMiddleware";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page] = useState(1);
  const [setTotalBlogs] = useState(0);
  const navigate = useNavigate();

  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const response = await API.get(`/blogs/${page}?popular=false`);
      const result = response.data.data.blog_result;
      setBlogs(result);
      setFilteredBlogs(result);
      setTotalBlogs(response.data.data.total);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, [page]);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    if (!query) {
      setFilteredBlogs(blogs);
    } else {
      const filtered = blogs.filter((blog) =>
        blog.title.toLowerCase().includes(query)
      );
      setFilteredBlogs(filtered);
    }
  };

  return (
    <Box
      className="pageWrapper"
      sx={{
        backgroundColor: "#E3F2FD",
        height: "100%",
        borderRadius: "24px 0 0 0",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        padding: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          mb: 2,
          flexShrink: 0,
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "16px",
        }}
      >
        <Typography sx={{ fontSize: "20px", fontWeight: "600" }}>
          Blogs
        </Typography>
      </Box>

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "16px",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>
            List of Blogs
          </Typography>
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <TextField
              size="small"
              placeholder="Search"
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Button
              size="small"
              variant="contained"
              onClick={() => navigate("/blogs/create")}
            >
              <AddIcon sx={{ marginRight: 1 }} />
              Create New Blog
            </Button>
          </Box>
        </Box>

        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            position: "relative",
            display: "flex",
            justifyContent:
              loading || filteredBlogs.length === 0 ? "center" : "flex-start",
            alignItems:
              loading || filteredBlogs.length === 0 ? "center" : "flex-start",
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : filteredBlogs.length === 0 ? (
            <Typography
              variant="h6"
              sx={{ textAlign: "center", color: "text.secondary" }}
            >
              No blogs available
            </Typography>
          ) : (
            <Box
              display="grid"
              gap={2}
              sx={{ gridTemplateColumns: "repeat(4, 1fr)", width: "100%" }}
            >
              {filteredBlogs.map((blog) => (
                <Card
                  key={blog.blog_id}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding: 2,
                    borderRadius: 2,
                    gap: 1.5,
                    border: "1px solid #E3F2FD",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      borderRadius: 1.2,
                      overflow: "hidden",
                    }}
                  >
                    <CardMedia
                      component="img"
                      height="120px"
                      image={blog.featured_image}
                    />
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        backgroundColor: "#3F95EA",
                        color: "#fff",
                        padding: "4px 8px",
                        borderRadius: 1.2,
                        fontSize: "0.90rem",
                        cursor: "pointer",
                        boxShadow: "0 0 0 4px white",
                      }}
                      onClick={() => navigate(`/blogs/details/${blog.blog_id}`)}
                    >
                      KNOW MORE
                    </Box>
                  </Box>

                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    color="#3F95EA"
                  >
                    <Box display="flex" alignItems="center">
                      <DateRangeIcon fontSize="small" sx={{ mr: 0.5 }} />
                      <Typography variant="body2" color="text.secondary">
                        {new Date(blog.created_at).toLocaleDateString()}
                      </Typography>
                    </Box>
                    <Box display="flex" alignItems="center">
                      <RemoveRedEyeIcon fontSize="small" sx={{ mr: 0.5 }} />
                      <Typography variant="body2" color="text.secondary">
                        {blog.views} Views
                      </Typography>
                    </Box>
                  </Box>

                  <CardContent sx={{ padding: "0px !important" }}>
                    <Typography
                      sx={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontWeight: "600",
                        WebkitLineClamp: 2,
                      }}
                    >
                      {blog.title}
                    </Typography>
                  </CardContent>
                </Card>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default BlogList;
